<template lang="pug">
v-sheet(color="secondary", align="center", elevation="1")
  v-alert(v-model="showAlert", dismissible, type="error") {{ alertMessage }}
  v-row.pl-1.pr-1(no-gutters)
    v-col(cols="1")
      .blue--text.headline(align="left")
        span {{ section.code }}
    v-col(cols="1")
      v-btn(
        icon,
        :disabled="!['GA', 'RM', 'SS'].includes(selectedUser.role)",
        v-if="myFeatures.eligibleFeatures.includes('REPORT')"
      )
        v-icon(
          v-if="section.status === STATUSES.OPEN",
          @click="vibrate(); closeSection()",
          large,
          color="green"
        ) mdi-toggle-switch
        v-icon(v-else, large, @click="vibrate(); openSection()", color="red") mdi-toggle-switch-off
    v-col(cols="9")
      .unwrapped.pt-1
        strong {{ section.name }}:
        code {{ getSeatsCount() }}
    v-col(cols="1")
      div(align="left")
        section-navigator(
          :section="section",
          v-if="myFeatures.eligibleFeatures.includes('REPORT')"
        )
  v-row.pl-1.pr-1(v-if="section.status === STATUSES.OPEN", no-gutters)
    v-col(cols="1")
      div(align="left")
        v-menu(bottom, left)
          template(v-slot:activator="{ on }")
            v-icon(v-on="on", @click="vibrate(); selectSection()", medium) mdi-filter-variant
          v-list.pa-0
            v-list-item.pa-2(
              v-for="service in activeSectionServices",
              :key="service.id"
            )
              v-list-item-content
                v-list-item-title(@click="vibrate(); selectService(service)")
                  strong(
                    v-if="selectedService && selectedService.id === service.id"
                  ) {{ service.name }}
                  span(v-else) {{ service.name }}
              v-list-item-action
                v-list-item-action-text
                  span
                    | {{  myFeatures.eligibleFeatures.includes(&apos;TIMER&apos;) ? getAge(service.createdTS)+&apos;m&apos;:moment(service.createdTS).format(&apos;LT&apos;)  }}
    v-col(cols="3")
      div(align="right")
        span Created:
        code
          | {{  restaurantServices.filter(s=&gt;s.status===STATUSES.CREATED &amp;&amp; s.sectionCode===section.code).length  }}
    v-col(cols="3")
      div(align="right")
        span Active:
        code
          | {{  restaurantServices.filter(s=&gt;s.status===STATUSES.INPROGRESS &amp;&amp; s.sectionCode===section.code).length  }}
    v-col(cols="3")
      //
        TODO NEXT RELEASE<div align="right">
        <span :key="ageKey">
        1hr
        <strong class="blink">:</strong> 5m
        </span>
        </div>
    v-col(cols="2")
      div(align="right")
        v-icon(
          v-if="['GA', 'RM', 'SS'].includes(selectedUser.role)",
          @click="vibrate(); addService()",
          medium
        ) mdi-plus-box-multiple
  v-row.pl-1.pr-1(v-if="section.status === STATUSES.PAID", no-gutters)
    .floor.pt-1
      floor-plan.pa-0(
        align="center",
        :tables="section.tables",
        :options="{ mode: 'view', serviceId: selectedService ? selectedService.id : null }",
        @onSelectSeat="handleSeat($event)"
      )
  v-dialog(v-model="addServiceDialog", persistent, max-width="290")
    v-card
      v-card-title.headline Create Service:
      v-card-text
        v-text-field(
          label="Enter Mobile#",
          v-model="editedItem.mobile",
          clearable
        )
        v-text-field(
          label="Enter Name",
          v-model="editedItem.customerName",
          clearable
        )
        v-text-field(
          disabled,
          label="Service Code",
          v-model="editedItem.name",
          clearable
        )
      v-card-actions
        v-spacer
        v-btn(
          color="green darken-1",
          text,
          @click="vibrate(); addServiceDialog = false"
        ) Cancel
        v-btn(
          color="green darken-1",
          text,
          @click="vibrate(); createService()"
        ) OK
</template>
<script>
import moment from "moment";
import { storeMixin } from "../../mixins/storeMixin.js";
import FloorPlan from "../shared/FloorPlan.vue";
import SectionNavigator from "../menus/SectionNavigaor.vue";

export default {
  name: "ezsection",
  mixins: [storeMixin],
  props: { section: Object },
  components: { SectionNavigator, FloorPlan },
  data() {
    return {
      collectionName: "services",
      addServiceDialog: false,
      editedItem: {},
      moment: moment,
      showAlert: false,
      alertMessage: "",
    };
  },
  computed: {
    activeSectionServices() {
      return this.restaurantServices.filter(
        (s) =>
          s.sectionCode ==
            (this.selectedSection && this.selectedSection.code) &&
          s.status != this.STATUSES.PAID
      );
    },
  },
  methods: {
    getSeatsCount() {
      return this.section.tables
        .map((t) => t.seats)
        .reduce((acc, s) => (acc += s.length), 0);
    },
    handleSeat({ _serviceKey, tidx, sidx }) {
      const tables = this.section.tables;
      if (_serviceKey) {
        if (_serviceKey == "rx") {
          tables[tidx].seats[sidx]._serviceKey = "";
        } else {
          this.selectSection(this.section);
          if (this.selectedService && this.selectedService.id === _serviceKey) {
            if (["GA", "RM", "SS"].includes(this.selectedUser.role)) {
              this.gotoSectionServices(_serviceKey);
            }
          } else {
            this.selectService(
              this.restaurantServices.find((s) => s.id === _serviceKey)
            );
          }
        }
      } else {
        tables[tidx].seats[sidx]._serviceKey = "rx";
      }
      this.$forceUpdate();
    },
    slurpSelectedSeats() {
      const seats = [];
      const tables = this.section.tables;
      for (let [tidx, t] of tables.entries()) {
        for (let [sidx] of t.seats.entries()) {
          if (tables[tidx].seats[sidx]._serviceKey == "rx") {
            seats.push([tidx, sidx].join("-"));
          }
        }
      }
      return seats;
    },
    getSeatsOptions() {
      const seats = [];
      this.editedItem.seats.forEach((s) => {
        let [tidx, sidx] = s.split("-");
        seats.push(`T${Number(tidx) + 1}S${Number(sidx) + 1}`);
      });
      return seats;
    },
    addService() {
      this.selectSection(this.section);
      const seats = this.slurpSelectedSeats();
      if (!seats.length) {
        this.alertMessage =
          "No seat selected. Please select seat(s) before adding service" +
          seats;
        this.showAlert = true;
      } else {
        this.editedItem = {
          _sectionKey: this.section.id,
          _groupKey: this.selectedGroup.id,
          _restaurantKey: this.selectedRestaurant.id,
          sectionCode: this.section.code,
          status: this.STATUSES.CREATED,
          customerName: "No name",
          mobile: "0000000000",
          seats: seats,
        };
        this.editedItem.name =
          this.section.code + ":" + this.getSeatsOptions().join("-");
        this.addServiceDialog = true;
      }
    },
    openSection() {
      if (this.selectedRestaurant.status === this.STATUSES.OPEN) {
        this.section.status = this.STATUSES.OPEN;
        const report = {
          _groupKey: this.selectedGroup.id,
          _restaurantKey: this.selectedRestaurant.id,
          _sectionKey: this.section.id,
          _restaurantReportKey: this.restaurantReport.id,
          code: this.section.code,
          inCharge: this.section.supervisorName,
          _inChargeId: this.section._supervisorId,
          reportType: "section",
          openTS: Date.now(),
          closedTS: "",
          reportText: "",
          status: this.STATUSES.OPEN,
        };
        this.createDoc({ collectionName: "reports", doc: report });
        this.updateFields({
          collectionName: "sections",
          docId: this.section.id,
          subDoc: { status: this.section.status },
        });
      } else {
        this.$emit(
          "openerror",
          "Section can't be opened before the restaurant. Please try after the restaurant is opened."
        );
      }
    },
    closeSection() {
      this.selectSection(this.section);
      const report = this.sectionReport(this.section.id);
      if (report._inChargeId !== this.selectedUser.id) {
        const message = `Section can be closed by only whoever opened it(${report.inCharge}). Please check if you have opened it and try closing again`;
        this.$emit("openerror", message);
      } else {
        const openOrders = this.sectionOrders.filter(
          (o) => o.status < this.STATUSES.CLEARED
        );
        const unpaidServices = this.sectionServices.filter(
          (s) => s.status < this.STATUSES.PAID
        );
        if (openOrders.length === 0 && unpaidServices.length === 0) {
          this.gotoSectionReportForCloseout();
        } else {
          const seed = {
            a: openOrders.length ? openOrders.length : unpaidServices.length,
            b: openOrders.length ? "orders" : "services",
            c: openOrders.length ? "open" : "unpaid",
            d: openOrders.length ? "served" : "paid",
          };
          const message = `There are still ${seed.a} ${seed.b} ${seed.c} in this section. Please wait until all ${seed.b} are ${seed.d}.`;
          this.$emit("openerror", message);
        }
      }
    },
    createService() {
      const payLoad = {
        collectionName: this.collectionName,
        doc: this.editedItem,
      };
      this.createDoc(payLoad);
      this.addServiceDialog = false;
      this.$forceUpdate();
    },
    gotoSectionServices(serviceId) {
      this.selectSection(this.section);
      this.$router.push(
        `/restaurants/${this.section._restaurantKey}/sections/${
          this.section.id
        }/services/${serviceId || ""}`
      );
    },
    gotoSectionReportForCloseout() {
      this.selectSection(this.section);
      this.$router.push({
        name: "sectionReport",
        params: {
          restaurantId: this.section._restaurantKey,
          sectionId: this.section.id,
          reportId: this.sectionReport(this.section.id).id,
        },
      });
    },
    getAge(timestamp) {
      const age = Math.round((Date.now() - timestamp) / 60000);
      return age > 120 ? ">120" : age;
    },
  },
};
</script>
<style >
.unwrapped {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.floor {
  width: 100%;
  height: 100%;
  border: solid 1px;
  border-color: gray;
  overflow-x: auto;
  overflow-y: none;
}
</style>